import React, { useState } from 'react';
import { toast } from 'react-toastify';
import Spinner from './Spinner';
import { adjustStock } from '../utils/api';

const StockAdjust: React.FC = () => {
    const [productId, setProductId] = useState<string>('');
    const [quantity, setQuantity] = useState<number>(0);
    const [reason, setReason] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleAdjustStock = async () => {
        if (!productId.trim()) {
            toast.error("Product ID is required.");
            return;
        }

        if (quantity === 0) {
            toast.error("Adjustment quantity cannot be zero.");
            return;
        }

        const productIdNum = parseInt(productId, 10);
        if (isNaN(productIdNum)) {
            toast.error("Invalid Product ID.");
            return;
        }

        setLoading(true);
        try {
            const response = await adjustStock(productIdNum, quantity, reason);
            toast.success(response.message || `Successfully adjusted stock for product ID ${productIdNum}.`);
            // Reset form after successful adjustment
            setProductId('');
            setQuantity(0);
            setReason('');
        } catch (err: any) {
            toast.error(err.message || "Failed to adjust stock.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-md">
            {loading && <Spinner />}
            <div className="mb-4">
                <label htmlFor="adjustProductId" className="block text-sm font-medium text-gray-700 mb-1">Product ID</label>
                <input
                    type="text"
                    id="adjustProductId"
                    value={productId}
                    onChange={(e) => setProductId(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="Enter Product ID"
                />
            </div>
            <div className="mb-4">
                <label htmlFor="adjustQuantity" className="block text-sm font-medium text-gray-700 mb-1">Adjustment Quantity (+/-)</label>
                <input
                    type="number"
                    id="adjustQuantity"
                    value={quantity}
                    onChange={(e) => setQuantity(parseInt(e.target.value, 10) || 0)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>
            <div className="mb-6">
                <label htmlFor="adjustReason" className="block text-sm font-medium text-gray-700 mb-1">Reason (Optional)</label>
                <input
                    type="text"
                    id="adjustReason"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                    placeholder="e.g., Stock take correction"
                />
            </div>
            <button
                onClick={handleAdjustStock}
                disabled={loading}
                className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-4 rounded transition duration-150 disabled:opacity-50"
            >
                {loading ? 'Processing...' : 'Adjust Stock'}
            </button>
        </div>
    );
};

export default StockAdjust;